module.exports = __webpack_public_path__ + "static/media/logo.32bd80a9.png";